import script from "./InternetConfigTelevision.vue?vue&type=script&setup=true&lang=ts"
export * from "./InternetConfigTelevision.vue?vue&type=script&setup=true&lang=ts"

import "./InternetConfigTelevision.vue?vue&type=style&index=0&id=b938fbf8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b938fbf8"]])

export default __exports__